export const adventuresVideos = [
  {
    country: "country_rw",
    videos: [
      {
        video: "https://res.cloudinary.com/dht699doy/video/upload/c_limit,w_1920,q_auto,f_auto/v1791899733/safari_localmarket_osb29k.mp4",
        thumbnail: "https://res.cloudinary.com/dht699doy/image/upload/c_limit,w_1920,q_auto,f_auto/v1779014938/kigali_car_free_zone_iuljt2.jpg",
        caption: "rw_local_markets",
        country: "country_rw",
        city: "Kigali",
        description: "rw_local_markets_desc"
      },
      {
        video: "https://res.cloudinary.com/dht699doy/video/upload/c_limit,w_1920,q_auto,f_auto/v1791899735/safari_kingpalce_acrtqt.mp4",
        thumbnail: "https://res.cloudinary.com/dht699doy/image/upload/c_limit,w_1920,q_auto,f_auto/v1782245533/Rwanda-Ethnographic-Museum-_lo2oct.jpg",
        caption: "rw_kings_palace",
        country: "country_rw",
        city: "Nyanza",
        description: "rw_kings_palace_desc"
      },
      {
        video: "https://res.cloudinary.com/dht699doy/video/upload/c_limit,w_1920,q_auto,f_auto/v1791899712/safari_gorilla2_eewur0.mp4",
        thumbnail: "https://res.cloudinary.com/dht699doy/image/upload/c_limit,w_1920,q_auto,f_auto/v1779016988/gorilla_scenic_o88uhp.png",
        caption: "rw_mountain_gorillas",
        country: "country_rw",
        city: "Musanze",
        description: "rw_mountain_gorillas_desc"
      },
      {
        video: "https://res.cloudinary.com/dht699doy/video/upload/c_limit,w_1920,q_auto,f_auto/v1791899722/safari_lakes2_eo9h8q.mp4",
        thumbnail: "https://res.cloudinary.com/dht699doy/image/upload/c_limit,w_1920,q_auto,f_auto/v1778223025/Rwandas-twin-lakes_rbva1s.gif",
        caption: "rw_lakes",
        country: "country_rw",
        city: "Rwamagana",
        description: "rw_lakes_desc"
      },
      {
        video: "https://res.cloudinary.com/dht699doy/video/upload/c_limit,w_1920,q_auto,f_auto/v1791899724/safari_memorial_gs4oj0.mp4",
        thumbnail: "https://res.cloudinary.com/dht699doy/image/upload/c_limit,w_1920,q_auto,f_auto/v1778223347/rwanda-genocide-memorial_iboujz.jpg",
        caption: "rw_memorial_sites",
        country: "country_rw",
        city: "Kigali",
        description: "rw_memorial_sites_desc"
      },
      {
        video: "https://res.cloudinary.com/dht699doy/video/upload/c_limit,w_1920,q_auto,f_auto/v1791899721/safari_inyambo_wtpfoc.mp4",
        thumbnail: "https://res.cloudinary.com/dht699doy/image/upload/c_limit,w_1920,q_auto,f_auto/v1782245533/Rwanda-Ethnographic-Museum-_lo2oct.jpg",
        caption: "rw_inyambo",
        country: "country_rw",
        city: "Nyanza",
        description: "rw_inyambo_desc"
      },
      {
        video: "https://res.cloudinary.com/dht699doy/video/upload/c_limit,w_1920,q_auto,f_auto/v1791899712/safari_canopy_yw7tqx.mp4",
        thumbnail: "https://res.cloudinary.com/dht699doy/image/upload/c_limit,w_1920,q_auto,f_auto/v1777731321/canopy_2_detqqd.jpg",
        caption: "rw_canopy_walk",
        country: "country_rw",
        city: "Nyungwe",
        description: "rw_canopy_walk_desc"
      },
      {
        video: "https://res.cloudinary.com/dht699doy/video/upload/c_limit,w_1920,q_auto,f_auto/v1791899745/safari_rhino_sqxe0g.mp4",
        thumbnail: "https://res.cloudinary.com/dht699doy/image/upload/c_limit,w_1920,q_auto,f_auto/v1779015355/rhinos_brmlth.jpg",
        caption: "rw_safari_game_drive",
        country: "country_rw",
        city: "Akagera",
        description: "rw_safari_game_drive_desc"
      }
    ]
  },
  {
    country: "country_tz",
    videos: [
      {
        video: "https://res.cloudinary.com/dht699doy/video/upload/c_limit,w_1920,q_auto,f_auto/v1791899801/safari_ballons_bn9pio.mp4",
        thumbnail: "https://res.cloudinary.com/dht699doy/image/upload/c_limit,w_1920,q_auto,f_auto/v1778223636/serengeti-migration_oj8mfp.jpg",
        caption: "tz_hot_air_balloon",
        country: "country_tz",
        city: "Serengeti",
        description: "tz_hot_air_balloon_desc"
      },
      {
        video: "https://res.cloudinary.com/dht699doy/video/upload/c_limit,w_1920,q_auto,f_auto/v1791899808/safari_canoe_uqopl7.mp4",
        thumbnail: "https://res.cloudinary.com/dht699doy/image/upload/c_limit,w_1920,q_auto,f_auto/v1779134470/kilimandjaro_hike_and_zanzibar_relax_l1bhmi.png",
        caption: "tz_canoeing",
        country: "country_tz",
        city: "Arusha",
        description: "tz_canoeing_desc"
      },
      {
        video: "https://res.cloudinary.com/dht699doy/video/upload/c_limit,w_1920,q_auto,f_auto/v1791899814/safari_oldcity_gcl8tc.mp4",
        thumbnail: "https://res.cloudinary.com/dht699doy/image/upload/c_limit,w_1920,q_auto,f_auto/v1779037262/stone-town-slavery-trail_gtqbgh.jpg",
        caption: "tz_stone_town",
        country: "country_tz",
        city: "Zanzibar",
        description: "tz_stone_town_desc"
      },
      {
        video: "https://res.cloudinary.com/dht699doy/video/upload/c_limit,w_1920,q_auto,f_auto/v1791899804/safari_ngorongoro_cnv7ia.mp4",
        thumbnail: "https://res.cloudinary.com/dht699doy/image/upload/c_limit,w_1920,q_auto,f_auto/v1777734238/ngorongoro_crater_wfbhro.jpg",
        caption: "tz_ngorongoro",
        country: "country_tz",
        city: "Ngorongoro",
        description: "tz_ngorongoro_desc"
      },
      {
        video: "https://res.cloudinary.com/dht699doy/video/upload/c_limit,w_1920,q_auto,f_auto/v1791899820/safari_snockel_ygu9wm.mp4",
        thumbnail: "https://res.cloudinary.com/dht699doy/image/upload/c_limit,w_1920,q_auto,f_auto/v1777734660/stone_island_zlqrmr.jpg",
        caption: "tz_snorkeling",
        country: "country_tz",
        city: "Zanzibar",
        description: "tz_snorkeling_desc"
      },
      {
        video: "https://res.cloudinary.com/dht699doy/video/upload/c_limit,w_1920,q_auto,f_auto/v1791899813/safari_massai_lycqjl.mp4",
        thumbnail: "https://res.cloudinary.com/dht699doy/image/upload/c_limit,w_1920,q_auto,f_auto/v1779038302/maasai-tribe_eqif0q.jpg",
        caption: "tz_maasai_village",
        country: "country_tz",
        city: "Arusha",
        description: "tz_maasai_village_desc"
      },
      {
        video: "https://res.cloudinary.com/dht699doy/video/upload/c_limit,w_1920,q_auto,f_auto/v1791899807/safari_kilimandjaro_f6wljo.mp4",
        thumbnail: "https://res.cloudinary.com/dht699doy/image/upload/c_limit,w_1920,q_auto,f_auto/v1777734478/kilimanjaro_hy0bg3.jpg",
        caption: "tz_kilimanjaro",
        country: "country_tz",
        city: "Moshi",
        description: "tz_kilimanjaro_desc"
      },
      {
        video: "https://res.cloudinary.com/dht699doy/video/upload/c_limit,w_1920,q_auto,f_auto/v1791899821/safari_serengeti_jvu4cc.mp4",
        thumbnail: "https://res.cloudinary.com/dht699doy/image/upload/c_limit,w_1920,q_auto,f_auto/v1777733572/serengeti_a3pwu2.jpg",
        caption: "tz_serengeti",
        country: "country_tz",
        city: "Serengeti",
        description: "tz_serengeti_desc"
      }
    ]
  },
  {
    country: "country_ug",
    videos: [
      {
        video: "https://res.cloudinary.com/dht699doy/video/upload/c_limit,w_1920,q_auto,f_auto/v1791899776/safari_rafting_apwzwv.mp4",
        thumbnail: "https://res.cloudinary.com/dht699doy/image/upload/c_limit,w_1920,q_auto,f_auto/v1777732851/murchisson-falls_pdzfch.jpg",
        caption: "ug_rafting",
        country: "country_ug",
        city: "Jinja",
        description: "ug_rafting_desc"
      },
      {
        video: "https://res.cloudinary.com/dht699doy/video/upload/c_limit,w_1920,q_auto,f_auto/v1791899774/safari_birds_omzmez.mp4",
        thumbnail: "https://res.cloudinary.com/dht699doy/image/upload/c_limit,w_1920,q_auto,f_auto/v1779030951/uganda-bird-watching_uhdc6x.jpg",
        caption: "ug_bird_watching",
        country: "country_ug",
        city: "Mabamba",
        description: "ug_bird_watching_desc"
      },
      {
        video: "https://res.cloudinary.com/dht699doy/video/upload/c_limit,w_1920,q_auto,f_auto/v1791899772/safari_gorilla3_co5lwc.mp4",
        thumbnail: "https://res.cloudinary.com/dht699doy/image/upload/c_limit,w_1920,q_auto,f_auto/v1779029553/bwindi-impenetrable_jplljz.jpg",
        caption: "ug_gorilla_trekking",
        country: "country_ug",
        city: "Bwindi",
        description: "ug_gorilla_trekking_desc"
      },
      {
        video: "https://res.cloudinary.com/dht699doy/video/upload/c_limit,w_1920,q_auto,f_auto/v1791899771/safari_kampala_rcwz9t.mp4",
        thumbnail: "https://res.cloudinary.com/dht699doy/image/upload/c_limit,w_1920,q_auto,f_auto/v1779029919/owino-market-kampala_cehorg.jpg",
        caption: "ug_city_center",
        country: "country_ug",
        city: "Kampala",
        description: "ug_city_center_desc"
      },
      {
        video: "https://res.cloudinary.com/dht699doy/video/upload/c_limit,w_1920,q_auto,f_auto/v1791899775/safari_nile_zf82gk.mp4",
        thumbnail: "https://res.cloudinary.com/dht699doy/image/upload/c_limit,w_1920,q_auto,f_auto/v1779030216/jinja-boat-cruise_gonl8a.webp",
        caption: "ug_nile_source",
        country: "country_ug",
        city: "Jinja",
        description: "ug_nile_source_desc"
      },
      {
        video: "https://res.cloudinary.com/dht699doy/video/upload/c_limit,w_1920,q_auto,f_auto/v1791899772/safari_owino_ycqvqu.mp4",
        thumbnail: "https://res.cloudinary.com/dht699doy/image/upload/c_limit,w_1920,q_auto,f_auto/v1779029919/owino-market-kampala_cehorg.jpg",
        caption: "ug_local_market",
        country: "country_ug",
        city: "Kampala",
        description: "ug_local_market_desc"
      },
      {
        video: "https://res.cloudinary.com/dht699doy/video/upload/c_limit,w_1920,q_auto,f_auto/v1791899776/safari_treelions_b95p37.mp4",
        thumbnail: "https://res.cloudinary.com/dht699doy/image/upload/c_limit,w_1920,q_auto,f_auto/v1777732605/queen_elizabeth_bssclm.jpg",
        caption: "ug_tree_lions",
        country: "country_ug",
        city: "Queen Elizabeth Park",
        description: "ug_tree_lions_desc"
      },
      {
        video: "https://res.cloudinary.com/dht699doy/video/upload/c_limit,w_1920,q_auto,f_auto/v1791899772/safari_dance_v3gadq.mp4",
        thumbnail: "https://res.cloudinary.com/dht699doy/image/upload/c_limit,w_1920,q_auto,f_auto/v1778221957/lake-bunyonyi_hlrkuw.jpg",
        caption: "ug_dance_experience",
        country: "country_ug",
        city: "Kampala",
        description: "ug_dance_experience_desc"
      }
    ]
  },
  {
    country: "country_bi",
    videos: [
      {
        video: "https://res.cloudinary.com/dht699doy/video/upload/c_limit,w_1920,q_auto,f_auto/v1791899844/safari_beach_rciowq.mp4",
        thumbnail: "https://res.cloudinary.com/dht699doy/image/upload/c_limit,w_1920,q_auto,f_auto/v1778222449/lake_tanganyika_bj_v3kts7.png",
        caption: "bi_saga_beach",
        country: "country_bi",
        city: "Bujumbura",
        description: "bi_saga_beach_desc"
      },
      {
        video: "https://res.cloudinary.com/dht699doy/video/upload/c_limit,w_1920,q_auto,f_auto/v1791899857/safari_drums_brfbkg.mp4",
        thumbnail: "https://res.cloudinary.com/dht699doy/image/upload/c_limit,w_1920,q_auto,f_auto/v1778222822/gishora_drums__1114946_pgk4kh.png",
        caption: "bi_gishora_drums",
        country: "country_bi",
        city: "Gishora",
        description: "bi_gishora_drums_desc"
      },
      {
        video: "https://res.cloudinary.com/dht699doy/video/upload/c_limit,w_1920,q_auto,f_auto/v1791899857/safari_waterfalls_v0cvmj.mp4",
        thumbnail: "https://res.cloudinary.com/dht699doy/image/upload/c_limit,w_1920,q_auto,f_auto/v1777732851/murchisson-falls_pdzfch.jpg",
        caption: "bi_karera_waterfalls",
        country: "country_bi",
        city: "Ngozi",
        description: "bi_karera_waterfalls_desc"
      },
      {
        video: "https://res.cloudinary.com/dht699doy/video/upload/c_limit,w_1920,q_auto,f_auto/v1791899844/safari_nilesource_m7euwj.mp4",
        thumbnail: "https://res.cloudinary.com/dht699doy/image/upload/c_limit,w_1920,q_auto,f_auto/v1779288341/stanley-livingstone_dvtnx8.jpg",
        caption: "bi_nile_source_monument",
        country: "country_bi",
        city: "Bururi",
        description: "bi_nile_source_monument_desc"
      },
      {
        video: "https://res.cloudinary.com/dht699doy/video/upload/c_limit,w_1920,q_auto,f_auto/v1791899852/safari_kibira_ndtd3v.mp4",
        thumbnail: "https://res.cloudinary.com/dht699doy/image/upload/c_limit,w_1920,q_auto,f_auto/v1779287939/kibira-rainforest_hqdrhy.jpg",
        caption: "bi_kibira_trek",
        country: "country_bi",
        city: "Cibitoke",
        description: "bi_kibira_trek_desc"
      },
      {
        video: "https://res.cloudinary.com/dht699doy/video/upload/c_limit,w_1920,q_auto,f_auto/v1791899855/safari_kirundo_vbnbia.mp4",
        thumbnail: "https://res.cloudinary.com/dht699doy/image/upload/c_limit,w_1920,q_auto,f_auto/v1779288543/Kibira-National-Park-cover_prhj55.jpg",
        caption: "bi_rwihinda_birdwatch",
        country: "country_bi",
        city: "Kirundo",
        description: "bi_rwihinda_birdwatch_desc"
      },
      {
        video: "https://res.cloudinary.com/dht699doy/video/upload/c_limit,w_1920,q_auto,f_auto/v1791899851/safari_boating_bhsxp6.mp4",
        thumbnail: "https://res.cloudinary.com/dht699doy/image/upload/c_limit,w_1920,q_auto,f_auto/v1778222613/rusizi-national-park_wpsiqs.jpg",
        caption: "bi_rusizi_boat",
        country: "country_bi",
        city: "Bujumbura",
        description: "bi_rusizi_boat_desc"
      },
      {
        video: "https://res.cloudinary.com/dht699doy/video/upload/c_limit,w_1920,q_auto,f_auto/v1791899860/safari_ruvubu_fndwja.mp4",
        thumbnail: "https://res.cloudinary.com/dht699doy/image/upload/c_limit,w_1920,q_auto,f_auto/v1779287939/kibira-rainforest_hqdrhy.jpg",
        caption: "bi_ruvubu_park",
        country: "country_bi",
        city: "Ruyigi",
        description: "bi_ruvubu_park_desc"
      }
    ]
  }
];
